export default __webpack_public_path__ + "static/media/Join_the_movement2.457afdcf.jpg";